import {ReqState} from "lib/reqstate";

export const ACTTYPE_INIT_STATE = "INIT_STATE";
export const ACTTYPE_DUMMY = "DUMMY";
export const ACTTYPE_SET_DEBUGMODE = "appState/SET_DEBUGMODE";
export const ACTTYPE_SET_BASEPATH = "appState/SET_BASEPATH";
export const ACTTYPE_SET_SITENAME = "appState/SET_SITENAME";
export const ACTTYPE_SET_PAGETITLE = "appState/SET_PAGETITLE";
export const ACTTYPE_LOGIN = "appState/LOGIN";
export const ACTTYPE_LOGOUT = "appState/LOGOUT";
export const ACTTYPE_SESSIONEXPIRE = "appState/SESSIONEXPIRE";
export const ACTTYPE_SET_LOGINERR = "appState/SET_LOGINERR";
export const ACTTYPE_CLR_LOGINERR = "appState/CLR_LOGINERR";
export const ACTTYPE_SET_EID = "appState/SET_EID";
export const ACTTYPE_SET_CID = "appState/SET_CID";
export const ACTTYPE_SET_TAG = "appState/SET_TAG";
export const ACTTYPE_LOADING_ENJILIST = "appState/LOADING_ENJILIST";
export const ACTTYPE_ERR_ENJILIST = "appState/ERR_ENJILIST";
export const ACTTYPE_SET_ENJILIST = "appState/SET_ENJILIST";
export const ACTTYPE_LOADING_ENJILIST2 = "appState/LOADING_ENJILIST2";
export const ACTTYPE_ERR_ENJILIST2 = "appState/ERR_ENJILIST2";
export const ACTTYPE_SET_ENJILIST2 = "appState/SET_ENJILIST2";


const initialState = {
    debugMode: 0,
    basePath: "",
    siteName: "",
    isLogin: false,
    isLoginError: false,
    
    session: "",
    sessionExpire: false,
    userInfo: {},
    pageTitle: "",

    // AdminApp
    enjiList: [],
    enjiList2: [],
    cid: "",
    tag: "",
    loadingStateEnjiList2: ReqState.INIT,

    // UserApp
    eid: "",
    loadingStateEnjiList: ReqState.INIT
};


const initState = function() {
    return {
        type: ACTTYPE_INIT_STATE
    };
};


const setDebugMode = function(debugMode: number) {
    return {
        type: ACTTYPE_SET_DEBUGMODE,
        value: debugMode
    };
};


const setBasePath = function(value: string) {
    return {
        type: ACTTYPE_SET_BASEPATH,
        value: value,
    };
};


const setSiteName = function(value: string) {
    return {
        type: ACTTYPE_SET_SITENAME,
        value: value,
    };
};


const setPageTitle = function(value: string) {
    return {
        type: ACTTYPE_SET_PAGETITLE,
        value: value
    };
};


const setEid = function(value: string) {
    return {
        type: ACTTYPE_SET_EID,
        value: value,
    };
};


const login = function(session: string, userInfo) {
    return {
        type: ACTTYPE_LOGIN,
        session: session,
        userInfo: userInfo,
    };
};


const logout = function() {
    return {
        type: ACTTYPE_LOGOUT
    };
};


const sessionExpire = function() {
    return {
        type: ACTTYPE_SESSIONEXPIRE
    };
};


const setLoginErr = function() {
    return {
        type: ACTTYPE_SET_LOGINERR
    };
};


const clrLoginErr = function() {
    return {
        type: ACTTYPE_CLR_LOGINERR
    };
};


const reducer = function (state, action) {
    if (typeof state === "undefined") {
        state = initialState;
    }

    switch (action.type) {
        case ACTTYPE_INIT_STATE:
            return {...initialState};
        case ACTTYPE_SET_DEBUGMODE:
            return Object.assign({}, state, {
                debugMode: action.value
            });
        case ACTTYPE_SET_BASEPATH:
            return Object.assign({}, state, {
                basePath: action.value
            });
        case ACTTYPE_SET_SITENAME:
            return Object.assign({}, state, {
                siteName: action.value
            });
        case ACTTYPE_LOGIN:
            return Object.assign({}, state, {
                isLoginError: false,
                isLogin: true,
                session: action.session,
                userInfo: action.userInfo,
            });
        case ACTTYPE_LOGOUT:
            // セッションの初期化
            return Object.assign({}, state, {
                isLoginError: initialState.isLoginError,
                isLogin: initialState.isLogin,
                session: initialState.session,
                userInfo: initialState.userInfo,
                eid: initialState.eid,
                enjiList: initialState.enjiList,
                enjiList2: initialState.enjiList2,
            });
        case ACTTYPE_SESSIONEXPIRE:
            return Object.assign({}, state, {
                sessionExpire: true,
            });
        case ACTTYPE_SET_LOGINERR:
            return Object.assign({}, state, {
                isLoginError: true
            });
        case ACTTYPE_CLR_LOGINERR:
            return Object.assign({}, state, {
                isLoginError: false
            });
        case ACTTYPE_SET_PAGETITLE:
            return Object.assign({}, state, {
                pageTitle: action.value
            });
        case ACTTYPE_SET_EID:
            return Object.assign({}, state, {
                eid: action.value
            });
        case ACTTYPE_SET_CID:
            return Object.assign({}, state, {
                cid: action.value
            });
        case ACTTYPE_SET_TAG:
            return Object.assign({}, state, {
                tag: action.value
            });
        case ACTTYPE_SET_ENJILIST:
            return Object.assign({}, state, {
                enjiList: action.value,
                loadingStateEnjiList: ReqState.DONE
            });
        case ACTTYPE_LOADING_ENJILIST:
            return Object.assign({}, state, {
                loadingStateEnjiList: ReqState.DOING
            });
        case ACTTYPE_ERR_ENJILIST:
            return Object.assign({}, state, {
                loadingStateEnjiList: ReqState.ERROR
            });
        case ACTTYPE_SET_ENJILIST2:
            return Object.assign({}, state, {
                enjiList2: action.value,
                loadingStateEnjiList2: ReqState.DONE
            });
        case ACTTYPE_LOADING_ENJILIST2:
            return Object.assign({}, state, {
                loadingStateEnjiList2: ReqState.DOING
            });
        case ACTTYPE_ERR_ENJILIST2:
            return Object.assign({}, state, {
                loadingStateEnjiList2: ReqState.ERROR
            });
        default:
            break;
    }

    return state;
};


export {
    reducer as default,
    initialState as appInitialState,
    initState,
    setDebugMode,
    setBasePath,
    setSiteName,
    setPageTitle,
    setEid,
    login,
    logout,
    sessionExpire,
    setLoginErr,
    clrLoginErr,
};
